import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {SpecialCompbaser} from "../../../components/compbaser";
import {timeout} from "../../../decorators/timeout";
import {ContainerService, LocalStoreService, StoreSelectorsService} from "../../../services";
import {IDialogGetAsset} from "../../../components/dialog-get-asset/dialog-get-asset.component";
import {ICategoryCheckItemNode, ICategoryTreeSelection} from "../../../components/category-tree/tree-service/tree-data.model";
import {ISceneImportTemplate, sceneTemplates} from "../../../../assets/accountTemplates/scene-template-constants";
import {SceneMimeTypes} from "../scene-blocks/mime-constants";
import {CategoryTreeComponent} from "../../../components/category-tree/category-tree.component";
import {actionGetSharedCommonContent, actionGetSharedCommonContentReply} from "../../../store/actions/user.actions";
import {Lib} from "../../../../libs/Lib";
import { ActionsSubject } from '@ngrx/store';
import { ofType } from '@ngrx/effects';
import * as _ from 'lodash';

interface ISceneTypes {
    label: string;
    icon: any;
    mimeType: string;
}

@Component({
    selector: 'app-create-scene',
    templateUrl: './create-scene.component.html',
    styleUrls: ['./create-scene.component.scss']
})
export class CreateSceneComponent extends SpecialCompbaser implements OnInit {

    @ViewChild('treeCategory') treeCategory: CategoryTreeComponent;

    @Input() dialogGetAsset;
    @Output() itemSelected = new EventEmitter<string>();

    jsonTypes: ISceneTypes[] = [];
    m_data: IDialogGetAsset; // = {mode: "SCENE:PLAYER", mimeType: SceneMimeTypes.Catalog};
    isFullFeatures;
    filter = '';
    enterprise: boolean;
    categoryTreeItems: Array<ICategoryCheckItemNode> = [];
    sharedContentTreeItems: Array<ICategoryCheckItemNode> = [];
    filteredJsonTypes: ISceneTypes[] = [];
    importType: 'categories' | 'shared' | 'specialized' = 'categories';
    isUpdatingEnterprise = false;
    sharedContents;
    sharedBusinessIds = [];

    constructor(
        private storeSelectorsService: StoreSelectorsService,
        private containerService: ContainerService,
        private localStoreService: LocalStoreService,
        private actionsSubj: ActionsSubject,
    ) {
        super();
    }

    ngOnInit(): void {
        this.initializeCategories();
        this.cod(
            this.storeSelectorsService.isFullFeatures().subscribe((v) => {
                this.isFullFeatures = v;
            })
        );
        this.cod(
            this.storeSelectorsService.getUser().subscribe((user) => {
                this.enterprise = Lib.GetAccountVersion(user) === 'ENTERPRISE_08' || Lib.GetAccountVersion(user) === 'ENTERPRISE_24';
            })
        );
        this.cod(
            this.actionsSubj.pipe(ofType(actionGetSharedCommonContentReply)).subscribe((reply: any) => {
                this.isUpdatingEnterprise = false;
                this.buildSharedContentTree(reply.value || []);
                this.sharedContents = reply.value || [];
            }),
        );
    }

    initializeCategories() {
        let selectedCategories = (this.localStoreService.getStorageValConfig('templateCategories') || '').split(";");
        const selectAll = selectedCategories.length === 1 && selectedCategories[0] === '';
        if (selectAll) {
            selectedCategories = [];
        }

        const categories = [];
        this.categoryTreeItems = [];

        Object.keys(sceneTemplates).forEach((templateName, n) => {
            const template: ISceneImportTemplate = {};
            template[templateName] = sceneTemplates[templateName];
            const folder = template[templateName][4].folder;
            // const businessId = template[templateName][0];
            // const templateId = template[templateName][2];
            // const name = template[templateName][4].name;
            // const server = template[templateName][1];
            // const mime = template[templateName][3];

            // if (folder === 'Presentation') {
            //     const businessId = template[templateName][0];
            //     const mainSceneId = template[templateName][4]['sceneIds'].split(' ')[0];
            //     console.log(`Playlist${n}: [${businessId}, 'ida.signage.me', SceneMimeTypes.Player, {name: '${template[templateName][4].name}', video: 'https://dev.signage.me/signplayer/signagePlayer?domain=galaxy.signage.me&businessId=${businessId}&sceneId=${mainSceneId}&token=', folder: 'Playlist'}, {account: 'example@ms.com'}]`);
            // }

            const indexOf = categories.findIndex((v) => v.item === folder);
            if (selectAll && !selectedCategories.includes(folder)) {
                selectedCategories.push(folder);
            }

            if (indexOf === -1) {
                categories.push({
                    id: _.uniqueId('__'),
                    item: folder,
                    children: [],
                    selected: selectedCategories.includes(folder),
                });
            }

            this.categoryTreeItems = [
                {
                    id: _.uniqueId('__'),
                    item: 'all categories',
                    children: categories,
                    selected: false,
                }
            ];
        });

        this.categoryTreeItems[0].children.sort((a, b) => a.item.toLowerCase().localeCompare(b.item.toLowerCase()));

        Object.keys(SceneMimeTypes).forEach((z) => {
            const v = SceneMimeTypes[z];
            if (this.storeSelectorsService.isMainSceneOrPlayer(v)) return;
            const block = this.storeSelectorsService.getBlockLabelByMimeType(v, false);
            if (!block) return;

            // if (!this.isFullFeatures) {
            //     if (LIMITED_MIME_RELEASE.findIndex((m) => m === v) === -1)
            //         return;
            // }
            this.jsonTypes.push({label: z, icon: block.icon ? block.icon : '', mimeType: v});
        });

        this.filteredJsonTypes = this.jsonTypes;
        this.m_data = {mode: "SCENE:PLAYER", filteredCategories: selectedCategories};
    }

    onItemSelected(selected) {
        if (this.itemSelected.observed) {
            this.itemSelected.emit(selected);
        }
    }

    onUpdateTree(categoryTreeSelection: ICategoryTreeSelection) {
        const categories = [];
        this.m_data = null;
        if (categoryTreeSelection.checklist.length > 0) {
            categoryTreeSelection.checklist.forEach((v) => {
                if (!v.expandable) categories.push(v.item);
            });
            this.m_data = {mode: "SCENE:PLAYER", filteredCategories: categories};
        }
        this.updateCategories(categories);
    }

    applyFilter(v) {
        this.filter = v ? v : '';
        this.filteredJsonTypes = this.jsonTypes.filter((j) => j.label && j.label.toLowerCase().indexOf(this.filter.toLowerCase()) > -1);
    }

    @timeout(222)
    selectType(event) {
        this.m_data = {mode: "SCENE:PLAYER", mimeType: event.value.mimeType};
        this.treeCategory.clearSelection();
        // this.router.navigateByUrl(`/editor/new/${event.value.mimeType}`);
    }

    private updateCategories(selectedCategories) {
        this.localStoreService.setStorageValConfig('templateCategories', selectedCategories.join(";") || "none");
    }

    private buildSharedContentTree(sharedContents) {
        this.sharedBusinessIds = [];
        sharedContents.forEach((item) => {
            const sceneContent = item.data?.scenes;
            if (sceneContent?.length > 0) {
                sceneContent.forEach((row) => {
                    if (!this.sharedBusinessIds.includes(row.businessId)) {
                        this.sharedBusinessIds.push(row.businessId);
                    }
                });
            }
        });

        this.sharedContentTreeItems = this.sharedBusinessIds.map((_businessId) => ({
            id: _.uniqueId("__"),
            item: _businessId,
            children: [],
            selected: true,
        }));

        this.sharedContentTreeItems.sort((a, b) => {
            if (a.item > b.item) return 1;
            if (b.item > a.item) return -1;
            return 0;
        });
    }

    syncSharedContents() {
        if (this.isUpdatingEnterprise) return;
        this.isUpdatingEnterprise = true;
        this.containerService.downloadedSharedScenes.next({});
        return this.storeSelectorsService.dispatch(actionGetSharedCommonContent({config: null}));
    }

    openGroup(type) {
        this.importType = type;
        if (!this.sharedContents?.length && type == 'shared') {
            return this.storeSelectorsService.dispatch(actionGetSharedCommonContent({config: null}));
        }
    }

    onUpdateShareContentTree(categoryTreeSelection: ICategoryTreeSelection) {
        if (categoryTreeSelection.checklist.length === 0) {
            this.sharedBusinessIds = [];
            return;
        } 
        const selectedIds = [];
        categoryTreeSelection.checklist.forEach((v) => {
            if (!v.expandable) {
                selectedIds.push(v.item);
            }
        });
        this.sharedBusinessIds = selectedIds;
    }
}
